import React, { useContext } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import CardSectionHeader from "components/framework/cards/CardSectionHeader";
import { DocumentModel } from "components/orders/types/DocumentModel";
import { OrderApi } from "services/apis/OrderApi";
import { handleFieldOrApiErrors } from "services/util/ApiUtil";
import { showInfoNotification, showErrorNotification } from "components/framework/notification/NotificationUtil";
import Document from "./Document";
import classNames from "classnames";
import { EnvironmentUtil } from "services/util/EnvironmentUtil";
import { AppContext } from "services/appContext/AppContext";
import { url } from "inspector";

const isMixNetworkUrl = EnvironmentUtil.isMixNetwork;

export default function Documents(props) {
  const intl = useIntl();
  const { appContext } = useContext(AppContext);
  const user = appContext.localStorageInfo.user;
  const url = window.location.href;
  const perms = user?.permissions;
  const pcAdmin = perms?.includes("Admin");
  const workQueue = perms?.includes("WorkQueue");
  const companyAdmin = perms?.includes("CompanyAdmin")
 
  // Viewer Context
  
  const getViewerContext = () => {
    if (!user) return "system";

    if (pcAdmin) return "portControlAdmin";
    if (workQueue) return "workQueue";

    const isVpop = user.spIdProfiles?.some(p => p.external === true);
    if (isVpop) return "vpop";

    if (!pcAdmin && !workQueue && !companyAdmin && url.includes("cspire") || url.includes("callza")) return "whiteLabelCustomer";
    if (!pcAdmin && !workQueue && !companyAdmin && url.includes("mix") || url.includes("mixnetworks")) return "wholesaleCustomer";

    return "directCustomer";
  };

  // Upload handler
  
  const storeFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (props.documents.find((x) => x.fileName === file.name)) {
      showErrorNotification(intl.formatMessage({ id: "orders.documents.duplicateUpload" }));
      return;
    }

    if (file.size > 3145728) {
      showErrorNotification(intl.formatMessage({ id: "orders.documents.sizeTooBigMessage" }));
      return;
    }

    if (file.type === "") {
      showErrorNotification(intl.formatMessage({ id: "orders.documents.noTypeMessage" }));
      return;
    }

    const newDocument: DocumentModel = { fileName: file.name, file, type: file.type };

    if (props.orderId) {

      OrderApi.addDocument(props.orderId, file)
        .then(() => {
          newDocument.uploaded = true;
          props.addDocument(newDocument);
          showInfoNotification(intl.formatMessage({ id: "orders.documents.addSuccessfullMessage" }));
        })
        .catch((error) => handleFieldOrApiErrors(error));
    } else {
      props.addDocument(newDocument);
    }

    e.target.value = "";
  };

  return (
    <>
      <CardSectionHeader 
        labelTranslationId={!isMixNetworkUrl ? "orders.documents" : "orders.loaDocument"} 
        required={isMixNetworkUrl}
      />

      <div className="mb-3">
        {props.documents.map((doc) => (
          <Document
            key={doc.fileName}
            orderId={props.orderId}
            orderRequestType={props.orderRequestType}
            document={doc}
            deleteDocument={props.deleteDocument}
            disabled={props.disabled}
            viewerContext={getViewerContext()}
          />
        ))}
      </div>

      <div
        className={classNames("custom-file", {
          "margin-top-29": props.documents.length === 0 && props.fileInputMarginTop
        })}
      >
        <input
          type="file"
          className="custom-file-input"
          lang="en"
          onChange={storeFile}
          disabled={props.disabled}
        />
        <label className="custom-file-label">
          <FormattedMessage id="orders.documents.placeholder" />
        </label>
      </div>
    </>
  );
}
